/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Why_Listening_Hero_Highlight_DevicesInputs */

const en_why_listening_hero_highlight_devices = /** @type {(inputs: Why_Listening_Hero_Highlight_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every device, one plan`)
};

const es_why_listening_hero_highlight_devices = /** @type {(inputs: Why_Listening_Hero_Highlight_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todos tus dispositivos, un plan`)
};

/**
* | output |
* | --- |
* | "Every device, one plan" |
*
* @param {Why_Listening_Hero_Highlight_DevicesInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const why_listening_hero_highlight_devices = /** @type {((inputs?: Why_Listening_Hero_Highlight_DevicesInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Why_Listening_Hero_Highlight_DevicesInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_why_listening_hero_highlight_devices(inputs)
	return en_why_listening_hero_highlight_devices(inputs)
});